export enum StorageType {
  ON_PREMISE = "ON_PREMISE",
  AWS_S3 = "AWS_S3",
  AZURE_BLOB = "AZURE_BLOB",
  TESTSIGMA = "TESTSIGMA"
}
